import { render, staticRenderFns } from "./index_swiper.vue?vue&type=template&id=bf006758&scoped=true"
import script from "./index_swiper.vue?vue&type=script&lang=js"
export * from "./index_swiper.vue?vue&type=script&lang=js"
import style0 from "./index_swiper.vue?vue&type=style&index=0&id=bf006758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf006758",
  null
  
)

export default component.exports